/**
 * Portão por modalidade da etapa "Laudo" (E74.F3.T10, ADR-0075 §7).
 *
 * Mesmo desenho do portão da pré-análise: o CASO decide a tela. O gate carrega
 * só o caso — fazê-lo dentro do corpo grafotécnico não bastaria, porque
 * `useLaudoData` roda incondicionalmente (é hook) e buscaria workspace,
 * assinaturas e narrativas de um caso que não tem nenhuma das três.
 *
 * Arquivo próprio (e não mais um bloco em `LaudoCasoPage`) porque aquele já
 * estava no teto de 400 linhas do lint — e o portão não é assunto do laudo
 * grafoscópico.
 */
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ptBR } from '@/i18n/pt-BR';
import { useApiClient } from '@/lib/api';
import { getCase, type CaseRecordData } from '@/lib/cases';
import { LaudoGrafotecnicaPage } from '@/pages/LaudoCasoPage';
import { LoadErrorState, LoadingState } from '@/pages/LaudoCasoPageStates';
import { LaudoEletronicoPage } from '@/pages/LaudoEletronicoPage';

export function LaudoCasoPage(): JSX.Element {
  const { id: caseId = '' } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const client = useApiClient();
  const [caso, setCaso] = useState<CaseRecordData | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    let cancelado = false;
    void (async () => {
      try {
        const registro = await getCase(client, caseId);
        if (!cancelado) setCaso(registro);
      } catch {
        if (!cancelado) setErro(ptBR.laudoCaso.errorGeneric);
      }
    })();
    return () => {
      cancelado = true;
    };
  }, [client, caseId]);

  if (caso === null) {
    return erro !== null ? (
      <LoadErrorState message={erro} onBack={() => navigate(`/casos/${caseId}`)} />
    ) : (
      <LoadingState />
    );
  }
  if (caso.modalidade === 'eletronica') return <LaudoEletronicoPage caso={caso} />;
  return <LaudoGrafotecnicaPage />;
}
